import { render, staticRenderFns } from "./ViewDatabase.vue?vue&type=template&id=b4f30e42&scoped=true&"
import script from "./ViewDatabase.vue?vue&type=script&lang=js&"
export * from "./ViewDatabase.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/common.css?vue&type=style&index=0&id=b4f30e42&scoped=true&lang=css&"
import style1 from "./ViewDatabase.vue?vue&type=style&index=1&lang=css&"
import style2 from "./ViewDatabase.vue?vue&type=style&index=2&id=b4f30e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f30e42",
  null
  
)

export default component.exports